angular.module('kareo.idle-configuration', [
  'kareo.ui.shared.modules.idleMonitor', 'kareo.environment', 'kareo.authentication'])
  .run([
    '$rootScope',
    'KareoEnvironment',
    'idleMonitor',
    'authService',
    function ($rootScope, environment, idleMonitor, authService) {
      var idleMonitorLogic = {
        idleTimeOut() {
          $rootScope.$apply(() => {
            authService.signout();
          });
        }
      };
      if (environment.idleTimeout) {
        idleMonitor.start(idleMonitorLogic);
      }
    }]);
